import { useContext } from "react";
import { AuftragsbestaetigungFromAngebotContext } from "@/pages/dokumente/auftragsbestaetigungFromAngebotContextValue";

export function useAuftragsbestaetigungFromAngebot() {
  const ctx = useContext(AuftragsbestaetigungFromAngebotContext);
  if (!ctx) {
    throw new Error(
      "useAuftragsbestaetigungFromAngebot() muss innerhalb von <AuftragsbestaetigungFromAngebotProvider> verwendet werden.",
    );
  }
  return ctx;
}
